<div class="row" *ngIf="isComercial || isBasica">
  <div class="col-lg col-md col-xs col-xl col-sm w-100">
    <mat-card class="mat-elevation-z8 w-100">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-lg col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{step}}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">

          <!-- Inicio Linha 1 -->

          <div class="row pt-3">
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Palha + Impurezas + Outras espec - MILHO (g)
                </mat-label>
                <input matInput id="txtCalc" #txtCalc maxlength="10" formControlName="Palha_Impurezas_Outras" readonly
                  (blur)="makeCalculations()" currencyMask class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtCalc.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Palha_Impurezas_Outras)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Desconto Palh + Imp + Ardi + Escl-MI (g)
                </mat-label>
                <input matInput id="txtCalcII" #txtCalcII maxlength="10" formControlName="Desc_Palh_Imp_Ardi_Escler"
                  readonly currencyMask class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtCalcII.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Desc_Palh_Imp_Ardi_Escler)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Quantidade Palh + Imp + Ardi + Escl-MI (%)
                </mat-label>
                <input matInput id="txtCalcIII" #txtCalcIII maxlength="10" formControlName="Qtde_Palh_Imp_Ardi_Escl"
                  readonly currencyMask class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtCalcIII.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Qtde_Palh_Imp_Ardi_Escl)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Fim Linha 1 -->

          <!-- Inicio linha 2 -->

          <div class="row pt-3">
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}"
                [ngClass]="{'mat-form-field-invalid': formulario.controls.Qtde_Palha.warning}">
                <mat-label class="InputLabelColor">Quantidade Palha - MILHO (%)
                </mat-label>
                <input matInput id="txtCalcIV" #txtCalcIV maxlength="10" formControlName="Qtde_Palha" readonly
                  currencyMask class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtCalcIV.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Qtde_Palha)}}
                </mat-error>
              </mat-form-field>
              
            </div>
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}"
                [ngClass]="{'mat-form-field-invalid': formulario.controls.Qtde_Sabugo.warning}">
                <mat-label class="InputLabelColor">Quantidade Sabugo - MILHO (%)
                </mat-label>
                <input matInput id="txtCalcV" #txtCalcV maxlength="10" formControlName="Qtde_Sabugo" readonly
                  currencyMask class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtCalcV.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Qtde_Sabugo)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Desconto (palha + imp) - MILHO (g)
                </mat-label>
                <input matInput id="txtCalcVI" #txtCalcVI maxlength="10" formControlName="Desc_Palh_Imp" readonly
                  currencyMask class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtCalcVI.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Desc_Palh_Imp)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Fim Linha 2 -->

          <!-- Incio Linha 3 -->

          <div class="row pt-3">
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso Grãos da Amostra - MILHO (g)
                </mat-label>
                <input matInput id="txtPesoGraosAmostra" #txtPesoGraosAmostra maxlength="10"
                  formControlName="Peso_Graos_Amostra" currencyMask class="InputBlockColor" readonly>
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtPesoGraosAmostra.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_Graos_Amostra)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}"
                [ngClass]="{'mat-form-field-invalid': formulario.controls.Qtde_Impurezas.warning}">
                <mat-label class="InputLabelColor">Quantidade Impurezas (%)
                </mat-label>
                <input matInput id="txtQtdeImpurezas" #txtQtdeImpurezas maxlength="10" formControlName="Qtde_Impurezas"
                  readonly currencyMask class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtQtdeImpurezas.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Qtde_Impurezas)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Sementes (g)</mat-label>
                <input matInput id="txtSementes" #txtSementes maxlength="10" formControlName="Sementes" readonly
                  currencyMask class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtSementes.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Sementes)}}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Fim Linha 3 -->

          <!-- Inicio Linha 4 -->

          <div class="row pt-3">
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Sub-total Descarte Grão - MILHO (g)
                </mat-label>
                <input matInput id="txtSubTotalDescGrao" #txtSubTotalDescGrao maxlength="10"
                  formControlName="Sub_Total_Desc_Grao_g" currencyMask readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtSubTotalDescGrao.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Sub_Total_Desc_Grao_g)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Sub-total Descarte Grão - MILHO (%)
                </mat-label>
                <input matInput id="txtSubTotalDescGraoPorc" #txtSubTotalDescGraoPorc maxlength="10"
                  formControlName="Sub_Total_Desc_Grao_porc" currencyMask readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtSubTotalDescGraoPorc.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Sub_Total_Desc_Grao_porc)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Umidade a deduzir - MILHO
                </mat-label>
                <input matInput id="txtUmidDeduzir" #txtUmidDeduzir maxlength="20" formControlName="Umidade_Deduzir"
                  readonly currencyMask class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtUmidDeduzir.value.length}} / 20</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Umidade_Deduzir)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Fim Linha 4 -->

          <!-- Inicio Linha 5 -->

          <div class="row pt-3">
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Desconto Impu + Palha (kg)</mat-label>
                <input matInput id="txtDescImpPal" #txtDescImpPal maxlength="10" formControlName="Desc_Impu_Palh"
                  readonly currencyMask class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtDescImpPal.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Desc_Impu_Palh)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Desconto Sabugo - MILHO (kg)
                </mat-label>
                <input matInput id="txtDescSabugo" #txtDescSabugo maxlength="10" formControlName="Desc_Sabugo" readonly
                  currencyMask class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtDescSabugo.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Desc_Sabugo)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Total Desc [pal + imp + sabugo] (kg)</mat-label>
                <input matInput id="txtTotDesc" #txtTotDesc maxlength="10" formControlName="Total_Desc_Pal_Imp_Sabugo"
                  readonly currencyMask class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtTotDesc.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Total_Desc_Pal_Imp_Sabugo)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Fim Linha 5 -->

          <!-- Inicio Linha 6 -->

          <div class="row pt-3">
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Desconto Umidade - MILHO (kg)</mat-label>
                <input matInput id="txtDescUmid" #txtDescUmid maxlength="10" formControlName="Desconto_Umidade" readonly
                  currencyMask class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtDescUmid.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Desconto_Umidade)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso Líquido Seco - MILHO (kg)
                </mat-label>
                <input matInput id="txtPesoLiquidoSeco" #txtPesoLiquidoSeco maxlength="10"
                  formControlName="Peso_Liquido_Seco" readonly currencyMask class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtPesoLiquidoSeco.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_Liquido_Seco)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso Líquido Úmido - MILHO (kg)
                </mat-label>
                <input matInput id="txtPesoLiquidoUmid" #txtPesoLiquidoUmid maxlength="10"
                  formControlName="Peso_Liquido_Umido" readonly currencyMask class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtPesoLiquidoUmid.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_Liquido_Umido)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Fim Linha 6 -->

          <!-- Inicio Linha 7 -->

          <div class="row pt-3">
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}"
                [ngClass]="{'mat-form-field-invalid': formulario.controls.Rendimento_Rw.warning}">
                <mat-label class="InputLabelColor">Rendimento RW => MPL (%)
                </mat-label>
                <input matInput id="txtRendimentoRw" #txtRendimentoRw maxlength="10" formControlName="Rendimento_Rw"
                  readonly currencyMask class="InputBlockColor">
                <i matSuffix class="fa fa-lock iconMenu"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtRendimentoRw.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Rendimento_Rw)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Criado por</mat-label>
                <input matInput id="txtCriadoPor" #txtCriadoPor maxlength="40" formControlName="criado_por" readonly
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="end">{{txtCriadoPor.value.length}} / 40</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.criado_por)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg">
              <mat-checkbox formControlName="validacao" (change)="showOptions($event)" [disabled]="disableCheckbox">
                Validação
              </mat-checkbox>
              <br>
              <p class="InputLabelColor">Responsável pela Validação:
                {{formulario.controls.resp_validacao?.value}}
              <p>
            </div>
          </div>

          <!-- Fim linha 7 -->
        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>
<div class="row" *ngIf="isPreBasica">
  <div class="col-lg col-md col-xs col-xl col-sm w-100">
    <mat-card class="mat-elevation-z8 w-100">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-lg col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{step}}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">

          <div class="row pt-3">
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">% Palha + Impureza do CERAR</mat-label>
                <input matInput id="txtPalhaImpurezaCerar" #txtPalhaImpurezaCerar maxlength="10"
                  formControlName="palha_impureza_cerar" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 2 }" readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.palha_impureza_cerar)}}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">% Sabugo no CERAR</mat-label>
                <input matInput id="txtSabugoCerar" #txtSabugoCerar maxlength="10" formControlName="sabugo_cerar"
                  currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }" readonly
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.sabugo_cerar)}}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">% Semente no CERAR</mat-label>
                <input matInput id="txtSementeCerar" #txtSementeCerar maxlength="10" formControlName="semente_cerar"
                  currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }" readonly
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.semente_cerar)}}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">% Palha da Amostra</mat-label>
                <input matInput id="txtPalhaAmostra" #txtPalhaAmostra maxlength="10" formControlName="palha_amostra"
                  currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }" readonly
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.palha_amostra)}}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso Líquido da Carga com Umidade</mat-label>
                <input matInput id="txtPesoLiquidoCargaUmidade" #txtPesoLiquidoCargaUmidade maxlength="10"
                  formControlName="peso_liquido_carga_umidade" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 2 }" readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.peso_liquido_carga_umidade)}}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Kg de Palha na Carga</mat-label>
                <input matInput id="txtPalhaNaCarga" #txtPalhaNaCarga maxlength="10" formControlName="palha_na_carga"
                  currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }" readonly
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.palha_na_carga)}}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Previsão de MPL (kg)</mat-label>
                <input matInput id="txtPrevisaoMPLKg" #txtPrevisaoMPLKg maxlength="10" formControlName="previsao_mpl_kg"
                  currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }" readonly
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.previsao_mpl_kg)}}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Previsão de MPL (%)</mat-label>
                <input matInput id="txtPrevisaoMPLPorcento" #txtPrevisaoMPLPorcento maxlength="10"
                  formControlName="previsao_mpl_porcento" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 2 }" readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.previsao_mpl_porcento)}}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Previsão de DS Grãos (kg)</mat-label>
                <input matInput id="txtPrevisaoDSGraosKg" #txtPrevisaoDSGraosKg maxlength="10"
                  formControlName="previsao_ds_graos_kg" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 2 }" readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.previsao_ds_graos_kg)}}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Previsão de DS Grãos (%)</mat-label>
                <input matInput id="txtPrevisaoDSGraosPorcento" #txtPrevisaoDSGraosPorcento maxlength="10"
                  formControlName="previsao_ds_graos_porcento" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 2 }" readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.previsao_ds_graos_porcento)}}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Perda no Processo</mat-label>
                <input matInput id="txtPerdaProcesso" #txtPerdaProcesso maxlength="10" formControlName="perda_processo"
                  currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }" (blur)="makeCalculationsPreBasica($event)">
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.perda_processo)}}</mat-error>
              </mat-form-field>
            </div>
          </div>


          <!-- Fim linha 7 -->
        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>